import PropTypes from 'prop-types';
import { FavoriteOption } from '../FavoriteOption';
import css from './favorite-menu-option.module.scss';
import sharedCss from './shared-menu-option.module.scss';

// exported for testing
const FavoriteMenuOption = ({ action, guideItem, className }) => {
  return (
    <FavoriteOption
      guideItem={guideItem}
      followActionOrOption={action}
      className={className}
      iconClassName={sharedCss.iconClassName}
      unFavoritedClassName={css.unFavoritedIcon}
    />
  );
};

FavoriteMenuOption.propTypes = {
  guideItem: PropTypes.object.isRequired,
  action: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default FavoriteMenuOption;
